(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-section-1"] && !Shopify.designMode) return;
  try {
    
// Product Image Carousel for Section 2
document.addEventListener('DOMContentLoaded', function() {
  const carouselContainer = document.querySelector('.product-carousel-container-2');
  if (!carouselContainer) return;

  const imagesContainer = carouselContainer.querySelector('.product-carousel-images-2');
  const images = carouselContainer.querySelectorAll('.carousel-image-2, .product-carousel-images-2 > div');
  const prevBtn = carouselContainer.querySelector('.carousel-prev-2');
  const nextBtn = carouselContainer.querySelector('.carousel-next-2');
  const currentCounter = carouselContainer.querySelector('.current-image-2');

  if (images.length <= 1) return;

  let currentIndex = 0;

  function updateCarousel() {
    imagesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
    if (currentCounter) {
      currentCounter.textContent = currentIndex + 1;
    }
  }

  function markSwipeSeen() {
    carouselContainer.classList.add('nesw-swipe-seen');
  }

  function nextImage(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    currentIndex = (currentIndex + 1) % images.length;
    updateCarousel();
    markSwipeSeen();
  }

  function prevImage(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateCarousel();
    markSwipeSeen();
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextImage, true);
    nextBtn.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }, true);
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', prevImage, true);
    prevBtn.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }, true);
  }

  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  imagesContainer.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  imagesContainer.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchStartX - touchEndX > swipeThreshold) {
      nextImage();
    }
    if (touchEndX - touchStartX > swipeThreshold) {
      prevImage();
    }
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevImage();
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextImage();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
